import React from 'react';

const Footer = function () {
    return <div className="footer view pt-20 pb-20">
        <p>Made by <a className="link" href="https://github.com/xomrau">Danny</a> (@xomrau)</p>
    </div>;
}

export default Footer;